import React from 'react'
import {Trans, translate} from 'react-i18next'

const ResetPasswordSuccessMessageText = () => (
  <Trans i18nKey="password-reset.success">
    text
    <br />
    <br />
    text
  </Trans>
)

export default translate()(ResetPasswordSuccessMessageText)
